import CookiePreferences from './CookiePreferences'

export default CookiePreferences
